import React, { useEffect } from 'react';
import {FaUserCircle} from "react-icons/fa"
import {AiOutlineCaretDown , AiFillShopping , AiFillCaretRight } from "react-icons/ai"
import { dashbordAdmin } from './dashbordAdmin';
import { Link, Route, Routes, useNavigate } from 'react-router-dom';
import CommandesList from './CommandesList';
import HomePageAdmin from './HomePageAdmin';
import BarTopAdmin from './BarTopAdmin';
import CreateNewAdmin from './CreateNewAdmin';
import { connected, currentUser } from '../../util/currentUser';

const AdminPage = () => {
    
    const navigate = useNavigate()

    useEffect(()=>{
        if(connected===false){
            navigate("/Connexion")
        }
    },[])
    
    const sideBarAdmin = ()=>{
        
        return dashbordAdmin.map((item , index)=>{
            return(
                <li key={index} className="navbar-item">
                    <p  data-bs-toggle="collapse" data-bs-target={"#"+ item.cName} aria-expanded="false" aria-controls="collapseExample">
                        {item.title} <span className='float-end'>{ item.titleIcon }</span>
                    </p>
                    <div className='collapse' id={item.cName}>
                        {
                            <div className='bg-white border rounded mb-2' key={index}>  
                                {item.content.map((content, index)=>{
                                    return(                  
                                        <p key={index} className='m-0 ps-3 w-100 border' >
                                            <Link to={content.path} className='nav-link'>
                                                {content.icon} {content.contentText }
                                            </Link>
                                        </p>               
                                    )
                                })}
                            </div>
                        }
                    </div>
                </li>
            )
        })
    }
    return (
        <div>
            <div className='row'>
                <div className="col-md-3 col-sm-4 bg-primary text-white " style={{minHeight:'100vh'}}>
                    <div className='col-12 m-0 p-0 rounded-circle m-auto my-2 shadow' style={{height:'200px',width:'200px',backgroundImage:'url("https://www.egora.fr/sites/egora.fr/files/sites/egora.fr/files/imce/celia_2_1.jpeg")',backgroundPosition:'center',backgroundSize:'cover'}}>
                    </div>
                    <ul className='navbar-nav ps-3 '>
                        <Link to="" className='text-white text-decoration-none mb-3'>Accueil</Link>
                        {sideBarAdmin()}
                    </ul>
                </div>
                <div className='col-md-9 col-sm-8 m-0 p-0'>
                    <BarTopAdmin></BarTopAdmin>
                    {/* <CommandesList></CommandesList> */}
                    <Routes>
                        <Route path='' element={<HomePageAdmin/>}></Route>
                        {
                            dashbordAdmin.map(item=>{
                                return item.content.map(content=>{
                                    return <Route path={content.path+"/*"} element={content.destination}></Route>
                                })
                            })
                        }
                    </Routes>
                </div>
            </div>
        </div>
    );
};

export default AdminPage;